import { Langs } from '../@types';

export const createLangHref = (currentLang: string, path: string) => {
	return currentLang === Langs.en ? path : '/' + currentLang + path;
};
